import { useContext } from "react";
import { PasswordPolicySettingsViewModel } from "../../generated/data-contracts";
import { AvisContext } from "../shared/context/AvisContext";

interface IPasswordPoliciesUlProps {
  policies: PasswordPolicySettingsViewModel;
}
export function PasswordPoliciesUl(props: Readonly<IPasswordPoliciesUlProps>) {
  const { policies } = props;
  const { res } = useContext(AvisContext);
  return (
    <ul>
      <li>
        {res(
          "user_ChangePassword_validation_requiredLength",
          policies.minLength.toString(),
        )}
      </li>
      {policies?.requiredUppercaseAndLowercase && (
        <li>{res("user_ChangePassword_validation_letterCase")}</li>
      )}
      {policies?.requiredSymbol && (
        <li>{res("user_ChangePassword_validation_requiredSymbol")}</li>
      )}
      {policies?.requiredDigit && (
        <li>{res("user_ChangePassword_validation_requiredDigit")}</li>
      )}
      {policies?.mustNotContainLogin && (
        <li>{res("user_ChangePassword_validation_preventContainLogin")}</li>
      )}
    </ul>
  );
}
